import types from '../types'
import Action from '../../types/Action'

const initialState = {
    loading: false,
    error: false,
    success: false,
    data: []
}

const languageReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case types.GET_LANGUAGES_REQUESTED: {
            return {
                loading: true,
                error: false,
                success: false,
                data: []
            }
        }
        case types.GET_LANGUAGES_FULFILLED: {
            return {
                ...state,
                loading: false,
                success: true,
                data: action.payload
            }
        }
        case types.GET_LANGUAGES_REJECTED: {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        }
        default:
            return state
    }
}

export default languageReducer